import { EnumHelper, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import LegalEntityType from "../../../Models/Catalogue/Classifications/LegalEntityType";
import SARSIDTypeCatalogueEntry from "../General/SARSIDTypeCatalogueEntry";
import { SARSDistributionType } from "../../../Models/Catalogue/Classifications/SARSDistributionType.enum";

export default class LegalEntityTypeCatalogueEntry extends CatalogueEntry<LegalEntityType> {

    constructor() {
        super("Legal Entity Types", LegalEntityType);
    }

    public get editRole() {
        return CatalogueRoles.LegalEntityTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.legalEntityTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveLegalEntityTypes;
    }

    public renderRow(item: LegalEntityType, meta: Model.TransformMetaType<LegalEntityType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.legalEntityTypeName} />
                <Catalogue.Column bind={meta.sarsidTypeId} catalogueType={SARSIDTypeCatalogueEntry} />
                <NeoGrid.Column bind={meta.sarsDistributionType} select={{ items: EnumHelper.asList(SARSDistributionType) }} />
                <NeoGrid.Column bind={meta.dwtExempt} />
                <NeoGrid.Column bind={meta.isIndividual} />
                <NeoGrid.Column bind={meta.isTrust} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}